// extracted by mini-css-extract-plugin
export default {"page-header":"PageHeader_page-header__YnpG8","page-title":"PageHeader_page-title__7SUA9","page-subtitle":"PageHeader_page-subtitle__LwLTN"};